import { create } from 'zustand';
import { RouteTheme } from '@/shared/styles/theme';

type ThemeOverrideState = {
  override: Partial<RouteTheme> | null;
  setOverride: (theme: Partial<RouteTheme>) => void;
  clearOverride: () => void;
};

const useRouteThemeStore = create<ThemeOverrideState>((set) => ({
  override: null,
  setOverride: (override) => set({ override }),
  clearOverride: () => set({ override: null }),
}));

export default useRouteThemeStore;
